import Folder from '../src/Folder/index.tsx';
export default Folder;
